import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AdminAuthContext } from './AdminAuthContext';

const AdminProtectedRoute = ({ children, permissions }) => {
  const { admin, loading } = useContext(AdminAuthContext);
  const location = useLocation();

  if (loading) return <div className="admin-route-loading">Checking secure session…</div>;
  if (!admin) return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />;
  if (permissions?.length && !permissions.includes(admin.permission)) {
    return <Navigate to="/admin" replace state={{ accessDenied: true }} />;
  }
  return children;
};

export default AdminProtectedRoute;
